import { inject } from 'mobx-react';
import { IMobxRootState } from '../../RootStore';
import {
    VIEW,
} from '../../interfaces';

import {
    FGTypography,
} from '@fg/design-system';
import { isViewType } from '../../utils/generalUtils';
import ChartExportButton from '../GQChart/ChartExportButton';
import ChartExportPreviewButton from '../GQChart/ChartExportPreviewButton';
import HeatmapScoreTypeSelection from './HeatmapScoreTypeSelection';
import { HeatmapScoreType } from './HeatmapTypes';
import MethodologiesButton from 'components/MethodologiesButton';
import HeatmapStore from 'stores/HeatmapStore';

type Props = {
    title?: string;
    scoreType?: HeatmapScoreType;
    countriesList?: number[];
};

export const HeatmapToolbar = inject(
    ({ heatmapStore }: IMobxRootState): Partial<Props> => {
        return {
            scoreType: heatmapStore.scoreType,
            title: heatmapStore.title,
            countriesList: heatmapStore.countriesList,
        };
    }
)(({ scoreType, title, countriesList }: Props) => {
    
    // In insights mode - export is disabled, user has the snapshot tool in the editor instead.
    const showExportBtn = !isViewType(VIEW.CREATE_INSIGHT);

    // For debugging. When preview button is clicked, it opens the export template URL (/#/export_chart) in a new tab,
    // with the current data sent as query params. Set true to enable.
    const showExportPreviewButton = false;
    const toggleScoreType = (newScoreType: HeatmapScoreType) => {
        if (newScoreType === scoreType) {
            return;
        }
        HeatmapStore.setScoreType(newScoreType);
    };
    return (
        <div className="heatmap-toolbar-buttons">
            <div
                className="chart-header-container">
                <div style={{ flex: 1 }}>
                    
                    <FGTypography
                        tag="h4"
                        variant="headline4"
                        color="strong">
                        {title}
                    </FGTypography>
                </div>
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'flex-end',
                    }}>
                    <HeatmapScoreTypeSelection
                        currentScoreType={scoreType}
                        onChangeScoreType={toggleScoreType}
                    />

                    {showExportBtn && <ChartExportButton hasCountriesSelected={countriesList.length > 0}/>}
                    {showExportPreviewButton && <ChartExportPreviewButton hasCountriesSelected={countriesList.length > 0}/>}
                    <MethodologiesButton />
                </div>
            </div>
        </div>
    );
});

export default HeatmapToolbar;
